import React from 'react'
import Hero from '../components/Hero'
import VideoSection from '../components/VideoSection'
import Services from '../components/Services'
import StockSection from '../components/StockSection'
import StockSlides from '../components/StockSlides'
import Marque from '../components/Marque'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'

const HomeMobile = (props) => {
  const {t, i18n} = useTranslation();
  const isRTL = i18n.language === 'ar';
    return (
        <div>
            <Hero
            dis={props.dis}
            motherclassName='pt-10 flex flex-col'
            className1='w-full flex gap-2 items-center justify-center h-full'
            className2='text-primary02 flex flex-col justify-center  w-full px-6 sm:px-10 md:px-16  '
            className3='w-full'
            classText1=' w-full xs:w-[95%] sm:w-[80%] md:w-[85%]'
            classText11='text-[23px] xs:text-[30px] sm:text-[35px] md:text-[40px]' 
            classText12='text-[17px] xs:text-[20px] sm:text-[25px] md:text-[30px]' 
            classText2='text-[15px] sm:text-[18px] md:text-[23px] w-full '
            classText3='text-[25px] sm:text-[30px] md:text-[35px] lg:text-[40px]'
            cljustify='flex flex-col gap-3 w-full'
            padd='p-6' />
            <VideoSection/>
            <Services 
                padd='px-6 md:px-10 '
                // Distribution classes
                motherclassName1='flex flex-col-reverse gap-10'
                className11=''
                className21=''
                className31='w-full flex justify-center'
                classmarginbottom1='mb-10 sm:mb-12 md:mb-14 lg:mb-16' 
                classbottom1='-bottom-8 sm:-bottom-12 md:-bottom-14 lg:-bottom-16' 
                classText11='text-[13px] xs:text-[17px] font-semibold sm:text-[26px] md:text-[30px] lg:text-[40px]'
                classSectionText11='text-[25px] sm:text-[40px] md:text-[42px] lg:text-[45px]'
                classSectionText21='text-[27px] xs:text-[28px] md:text-[35px] lg:text-[40px]'
                classSectionText31='text-[20px] md:text-[25px] lg:text-[27px]'
                classSectionText41='text-[12px] xs:text-[17px] md:text-[23px] lg:text-[25px]'
                classwidth1='w-[85%] xs:w-[85%] sm:w-[82%] md:w-[78%] lg:w-[75%]'
                cljustify1='flex flex-col gap-3 w-full' 
                // Stock classes
                motherclassName='flex flex-col relative aspect-[16/11] sm:aspect-video justify-start items-center'
                className1='w-full h-[90%] '
                className2={`absolute bottom-0 w-[95%] md:w-[90%] h-[95%] sm:h-[90%] mx-auto aspect-[16/9] sm:aspect-[16/6] bg-primary rounded-3xl ${isRTL ? 'pr-4  sm:pr-12 md:pr-14 lg:pr-24' : 'pl-4  sm:pl-12 md:pl-14 lg:pl-24'} py-4 sm:py-8 md:py-12 flex flex-col items-center justify-center gap-3 xs:gap-4 sm:gap-8 md:gap-10 lg:gap-16`}
                className3='gap-3 sm:gap-4  md:gap-6 lg:gap-8'
                className4='gap-3 sm:gap-4 md:gap-6 pl-4 md:pl-6 lg:pl-8'
                classiconpadd='p-2 lg:p-4' 
                classicon='w-6 sm:w-12 md:w-16 lg:w-20' 
                classGap1='gap-1 sm:gap-2 md:gap-3 lg:gap-4'
                classAfter='relative after:absolute after:content-[""] after:w-full after:h-[1px] after:bg-white/50 after:left-0 after:-bottom-2 sm:after:-bottom-4 md:after:-bottom-6 lg:after:-bottom-8'
                classAbsolute={`top-[calc(100%+8px)] sm:top-[calc(100%+16px)] md:top-[calc(100%+24px)] lg:top-[calc(100%+32px)] ${isRTL ? '-left-[45%] sm:-left-[70%]' : '-right-[20%] xs:-right-[25%] sm:-right-[30%]'}  h-[70px] xs:h-[100px] sm:h-[200px] md:h-[250px] lg:h-[300px]`}
                classHeader1='text-[13px] xs:text-[17px] sm:text-[22px] md:text-[27px] lg:text-[35px]'
                classText1='text-[8px] xs:text-[10px] sm:text-[18px] md:text-[18px] lg:text-[23px]'
                classHeader2='text-[11px] xs:text-[13px] sm:text-[20px] md:text-[23px] lg:text-[32px]'
                classHeader3='text-[10px] xs:text-[12px] sm:text-[15px] md:text-[20px] lg:text-[25px]'
                // rooms classes
                padd2='px-6 sm:px-20 md:px-28 lg:px-36'
                motherclassName2='flex flex-col  justify-center items-center gap-6 sm:gap-8'
                className12='w-full flex flex-col aspect-[16/10] sm:aspect-video md:aspect-[16/8] justify-center items-center gap-3 xs:gap-4 sm:gap-6 md:gap-8'
                className22=' py-2 px-4'
                className32=' w-14 sm:w-20 md:w-28 lg:w-36'
                className42='text-[17px] xs:text-[20px] sm:text-[30px] md:text-[37px] lg:text-[45px]'
                className52='w-[80%] text-[] xs:text-[13px] sm:text-[17px] md:text-[22px] lg:text-[27px]'
            />
            <StockSlides 
                motherclassName='flex flex-col justify-center items-center gap-8 mt-10'
                className1='w-full flex flex-col gap-6 justify-center items-start px-6 sm:px-20 md:px-28 lg:px-36'
                className2=' text-[20px] xs:text-[25px] sm:text-[30px] md:text-[35px] lg:text-[40px] w-full sm:w-[80%]'
                className3='text-[15px] xs:text-[18px] sm:text-[20px] md:text-[22px] lg:text-[25px] leading-[25px]'
                className4='gap-2 sm:gap-3 text-[15px] xs:text-[17px] sm:text-[20px] md:text-[25px] leading-[40px]'
                className5='w-full aspect-[16/8] md:aspect-[16/6] pl-[100%] md:pl-[50%] relative'
            />
                      
          <Marque 
            padd='px-6 sm:px-20 md:px-28 lg:px-36 w-full  aspect-[16/3] lg:aspect-[16/2] my-4 sm:my-6 md:my-10 lg:my-20'
            motherclassName='w-full h-full flex flex-row  justify-around items-center bg-primary02'
            className1='text-[10px] xs:text-[15px] sm:text-[18px] md:text-[20px] lg:text-[25px]'
          />
          <Footer/>
        </div>
      )
}

export default HomeMobile